import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { PageService } from '../services/page.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  contactForm!: FormGroup;
  errors: any;
  invalidForm: boolean;
  isFormSaving: any;
  isSubmitted: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private pageService: PageService,
    private el: ElementRef,
  ) { }

  ngOnInit(): void {
    this.contactForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', Validators.required],
      message: ['']
    });
  }

  onSubmit() {
    this.invalidForm = true;
    if (this.contactForm.valid) {
      this.invalidForm = false;
      this.isFormSaving = true;
      const userData = this.contactForm.value;
      this.pageService.sentContactMail(userData).subscribe({
        next: (response) => {
          this.isSubmitted = true;
          this.isFormSaving = false;
          this.contactForm.reset();
        }, error: (error) => {
          this.isFormSaving = false;
          this.errors = error ? error : null;
        }
      }
      );
    } else {
      this.invalidForm = true;
      const target = this.el.nativeElement.querySelector('.ng-invalid:not(form):not(div)');
      if (target) {
        target.focus();
      }
    }
  }

}
